import { ProviderId } from '@/features/Auth/providers/types'

/**
 * Whether the registration form still has to ask for a password.
 *
 * Decided once, when the flow enters registration, and carried on the state next to the
 * prefill. It used to be re-derived inside the form from the signed-in Firebase user, which
 * is a second source for the same question — and the two disagreed: the prefill would fill
 * the name and address while the password fields stayed, because one read the machine and
 * the other read the session.
 *
 * Only an account being created from an address and password needs one. Every other provider
 * arrives holding a credential, including LinkedIn, whose Firebase record is minted from a
 * custom token and carries no provider ids at all. See EPIC-005.
 */
export function needsPassword(provider: ProviderId): boolean {
  return provider === 'email'
}
